import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76db6fa7")

_pushScopeId("data-v-76db6fa7")
const _hoisted_1 = /*#__PURE__*/_createVNode("h2", null, "予約登録", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("戻る ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("次へ ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("登録 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("予約登録してもいいですか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_temporary_patient = _resolveComponent("temporary-patient")
  const _component_select_patient = _resolveComponent("select-patient")
  const _component_appointment = _resolveComponent("appointment")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_button_frame = _resolveComponent("vue-button-frame")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      (_ctx.page===0 && _ctx.patientType==='tmp')
        ? (_openBlock(), _createBlock(_component_temporary_patient, {
            key: 0,
            ref: "temporaryPatientRef"
          }, null, 512))
        : _createCommentVNode("", true),
      (_ctx.page===0 && _ctx.patientType==='sel')
        ? (_openBlock(), _createBlock(_component_select_patient, {
            key: 1,
            onAppointment: _ctx.onAppointment
          }, null, 8, ["onAppointment"]))
        : _createCommentVNode("", true),
      (_ctx.page===1)
        ? (_openBlock(), _createBlock(_component_appointment, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(_component_vue_button_frame, null, {
        left: _withId(() => [
          (_ctx.page<=1)
            ? (_openBlock(), _createBlock(_component_normal_button, {
                key: 0,
                class: "vue-button-frame-button",
                state: "normal",
                onClick: _ctx.onPrev
              }, {
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        right: _withId(() => [
          (_ctx.page===0 && _ctx.patientType==='tmp')
            ? (_openBlock(), _createBlock(_component_normal_button, {
                key: 0,
                class: "vue-button-frame-button",
                state: "normal",
                onClick: _ctx.onNext
              }, {
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.page===1)
            ? (_openBlock(), _createBlock(_component_normal_button, {
                key: 1,
                class: "vue-button-frame-button",
                state: "warning",
                disabled: _ctx.errorStartTime !== undefined || _ctx.errorEndTime !== undefined || _ctx.overlap,
                onClick: _ctx.onSubmit
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmRef",
        onYes: _ctx.yes
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})